var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout"},[_c('div',{staticClass:"checkout-heading"},[_c('h2',[_vm._v(_vm._s(_vm.trans.text['thank-you'].title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.trans.text['thank-you'].redirectMessage))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }